import BlindsAndShuttersMeasurementValues from "./BlindsAndShuttersMeasurementValues";

export default BlindsAndShuttersMeasurementValues